<template>
  <div class="ContentBox">
    <!-- 固定菜单 -->
    <div class="tools" style="display: none">
      <div>
        <img src="@/assets/zixun.png" />
      </div>
      <div @click="toLink('/Remark')">
        <img src="@/assets/mind.png" />
      </div>
    </div>
    <!-- 头 -->
    <div class="HomeHeardBox">
      <div class="commonBox">
        <Tops />
      </div>
      <el-carousel
        class="bannerBox"
        trigger="click"
        indicator-position="outside"
      >
        <el-carousel-item v-for="(item,i) in BannerList" :key="i">
          <!-- <img :src="item.FileUrl" /> -->
            <img src="@/assets/banner.jpg" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 中 -->
    <div class="ContMiddle">
      <!-- 1 -->
      <div class="Middle_TopBox">
        <div class="TopBox_left">
          <h3>我们的产品</h3>
          <div class="t1">秉承“坚持、承当、奉献、包容”的经营理念，为用户提供专业的、量身定制的数据资源服务。</div>
          <div class="tLine"></div>
          <div class="t1"> 公司自主研发了司法考试模考系统、公安机关人民警察执法资格考试系统、执法教育培训考试平台系统、行政执法监督平台等围绕依法行政、为政府单位提供法律数据支持系列产品。</div>
          <router-link to="/Product?id=2">  <img class="t_rightIcon" src="@/assets/icon-3.png"/></router-link>
        </div>
        <div class="TopBox_right">
          <div class="TopBox_right_Item" v-for="(v, i) in ArrList" :key="i">
            <img v-if="v.Hot" src="@/assets/NEW.png" class="newBg" />
            <div class="Item_Title">{{v.Title}}</div>
            <p class="Item_Txt">{{v.Describe}}</p>
            <div class="Item_BtnBox">
              <span @click="ApplyStatus=true">申请试用</span><span @click="toGo(v.Url)">访问系统</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 2 -->
      <div class="Middle_TwoBox">
        <img src="@/assets/bt-1.png" class="TwoBoxImg" />
        <div class="TwoBox_middel">
          <!-- 新闻资讯 start-->
          <div class="ItemBox">
            <img src="@/assets/bg-2.jpg" />
            <span class="spanTitle">公司资讯</span>
            <div class="Item_Txt">
              <div class="TxtBox" v-for="(v, i) in ArtList['art_1']" :key="i" @click="toDre(v.ID,2)">
                <div>
                 {{v.Title}}
                </div>
                <span>{{v.ShowTime.substr(0,10)}}</span>
              </div>
            </div>
          </div>
          <div class="ItemBox">
            <img src="@/assets/bg-3.jpg" />
            <span class="spanTitle">国家文件</span>
            <div class="Item_Txt">
              <div class="TxtBox" v-for="(v, i) in ArtList['art_2']" :key="i" @click="toDre(v.ID,4,v.Url)">
                <div>
                 {{v.Title}}
                </div>
                <span>{{v.ShowTime.substr(0,10)}}</span>
              </div>
            </div>
          </div>
          <div class="ItemBox">
            <img src="@/assets/bg-4.jpg" />
            <span class="spanTitle">地方文件</span>
            <div class="Item_Txt">
              <div class="TxtBox" v-for="(v, i) in ArtList['art_3']" :key="i" @click="toDre(v.ID,4,v.Url)">
                <div>
                 {{v.Title}}
                </div>
                <span>{{v.ShowTime.substr(0,10)}}</span>
              </div>
            </div>
          </div>
          <!-- 新闻资讯  end -->
        </div>
      </div>
    </div>
    <!-- 3 -->
    <div class="Middle_ThreeBox">
      <div class="ThreeContBox">
        <img src="@/assets/bt-2.png" class="TwoBoxImg" />
        <div class="ThreeBox">
          <div class="ItemBox" v-for="(v, i) in CusBetterList" :key="i">
            <img :src="v.icon" />
            <div class="Item_t1">{{v.title}}</div>
            <div class="Item_t2">·····</div>
            <div class="Item_t3">{{v.cont}}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 4 -->
    <div class="Middle_FourBox">
      <div class="FourContBox">
        <img src="@/assets/bt-3.png" class="TwoBoxImg" />
        <div class="ItemBox">
          <img src="@/assets/gywm.jpg" />
          <div class="ItemTxt">
            <div class="ItemT1">专业 高效的团队</div>
            <div class="ItemT2">
              四川万象坤信科技有限公司专业从事数据库及信息技术开发，是在大西部地区致力于政府机构行政执法大数据综合信息整合传输的高新技术企业和软件企业。公司自主研发了司法考试模考系统、公安机关人民警察执法资格考试系统、执法教育培训考试平台系统、行政执法监督……
            </div>
            <router-link to="/About?id=13" style="text-decoration:none">
              <div class="ItemT3"> 查看更多... </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <!-- 置顶 -->
    <!-- <img src="@/assets/top.png" class="ToTop" @click="topTop"> -->
    <!-- footer -->
    <!-- 申请 -->
    <transition name="bounce">
         <ApplyBox v-if="ApplyStatus" :ApplyStatus="ApplyStatus" @CanCle="CanCle"/>
    </transition>
      <!-- <el-drawer
  title="我嵌套了 Form !"
  :visible.sync="ApplyStatus"
  direction="ltr"
  custom-class="demo-drawer"
  ref="drawer"
  >
  <div class="demo-drawer__content">
    <div class="demo-drawer__footer">
      <el-button @click="cancelForm">取 消</el-button>
      <el-button type="primary" @click="$refs.drawer.closeDrawer()" :loading="loading">{{ loading ? '提交中 ...' : '确 定' }}</el-button>
    </div>
  </div>
</el-drawer> -->
    <!-- 申请试用 -->
    <Footer />
  </div>
</template>

<script>
import Tops from "@/components/PubBox/hearTop.vue";
import Footer from "@/components/PubBox/footer.vue";
import ApplyBox from "@/components/PubBox/ApplyBox.vue";
import { GetFilesInfoByCid ,GetNewsInfoByCid} from "@/requestPub/api";
import icon4 from "@/assets/icon-4.png";
import icon5 from "@/assets/icon-5.png";
import icon6 from "@/assets/icon-6.png";
export default {
  components: {
    Tops,
    Footer,
    ApplyBox
  },
  data() {
    return {
      ApplyStatus:false,
      BannerList:new Array(), //轮播图
      ArrList:new Array(),// 考试列表
      CusBetterList:[{icon:icon4,title:'快速部署',cont:'无需购置任何硬件，共享平台光速部署'},{icon:icon5,title:'高端设计',cont:'主流设计风格，极致交互体验，提升工作效率'},{icon:icon6,title:'安全稳定',cont:'平台运行于阿里云计算中心多备份容灾保障，安全稳定'}],
      ArtList:{
        art_1:[],
        art_2:[],
        art_3:[],
      }, //新闻资讯列表
    };
  },
  mounted() {
    this.DefaultInfo();
    // async ()=>{
    //        // 轮播图
    //       GetFilesInfoByCid({ Cid: 1 }).then((res) => {
    //         this.BannerList = res.Data.row;
    //       });
    //         await function(){
    //           //首页产品介绍列表
    //           GetNewsInfoByCid({ Cid: 2 }).then((res) => {
    //             this.ArrList = res.Data.row;
    //           });
    //         }
    //         await (()=>{
    //           // 新闻资讯的列表数据
    //           GetNewsInfoByCid({ Cid: 5 }).then((res) => {
    //             this.ArtList['art_1'] = res.Data.row;
    //           });
    //         })
    //         await (()=>{
    //         GetNewsInfoByCid({ Cid: 15 }).then((res) => {
    //               this.ArtList['art_2'] = res.Data.row;
    //             });
    //         })
    //         await (()=>{
    //           GetNewsInfoByCid({ Cid: 16 }).then((res) => {
    //             this.ArtList['art_3']  = res.Data.row;
    //           }); 
    //         })
    // }
  },
  methods: {
    CanCle(){
      this.ApplyStatus =false;
    },
    DefaultInfo(){
         GetFilesInfoByCid({ Cid: 1 }).then((res) => {
            this.BannerList = res.Data.row;
          });
       //首页产品介绍列表
              GetNewsInfoByCid({ Cid: 2 }).then((res) => {
                this.ArrList = res.Data.row;
              });
        // 新闻资讯的列表数据
              GetNewsInfoByCid({ Cid: 5 }).then((res) => {
                this.ArtList['art_1'] = res.Data.row;
              });
        GetNewsInfoByCid({Cid:10,}).then((e)=>{
            this.ArtList['art_2'] = e.Data.row;
        })
             GetFilesInfoByCid({ Cid: 11 }).then((res) => {
                this.ArtList['art_3']  = res.Data.row;
              }); 
    },
    toGo(n){
      window.open(n);
    },
    toLink(n) {
      this.$router.push("/Remark");
    },
    toDre(n,t,u) {
      if(t==4){
        window.open(u)
      }else{
              this.$router.push("/ListArtInfo?ids="+n);
      }
    },
    topTop() {
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
        if (top <= 0) {
          clearInterval(timeTop);
        }
      }, 10);
    },
  },
};
</script>
<style lang="scss">
.HomeHeardBox {
  position: relative;
  .commonBox {
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 59px; // 减 1px 的底部边框
    z-index: 111;
  }

  .bannerBox {
    height: 580px;
    .el-carousel__container {
      height: 100%;
    }
    .el-carousel__indicators--outside {
      position: absolute;
      bottom: 100px;
    }
    .el-carousel__item {
      img,
      .el-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
}

.tools {
  z-index: 999999;
  position: fixed;
  right: 0;
  top: 50%;
  margin-top: -75px;
  width: 50px;
  height: 150px;
  background: #ffffff;
  box-shadow: 0px 5px 20px 10px rgba(65, 96, 206, 0.1);
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  div {
    text-align: center;
    &:hover {
      cursor: pointer;
    }
    img {
      height: 35px;
      margin: 0 auto;
      // display: block;
    }
  }
  div:nth-child(1)::after {
    content: "咨询";
    font-size: 13px;
    font-weight: 400;
    display: block;
  }
  div:nth-child(2)::after {
    content: "建议";
    font-size: 13px;
    font-weight: 400;
    display: block;
  }
}
// 中
.ContMiddle {
  z-index: 10;
  position: relative;
  width: 1260px;
  margin: 0 auto;
  margin-top: -80px;
  overflow: hidden;
  .Middle_TopBox {
    width: 100%;
    height: fit-content;
    display: inline-flex;
     min-height: 520px;
    .TopBox_left {
      width: calc(20% - 40px);
      padding: 0 20px;
      background: rgba(65, 96, 206, 1);
      color: #fff;
      position: relative;
      text-align: left;
      .t_rightIcon {
        position: absolute;
        right: 20px;
        bottom: 70px;
      }
      .t1 {
        font-size: 13px;
        letter-spacing: 2px;
        line-height: 25px;
      }
      .tLine {
        height: 1px;
        background: rgba(255, 255, 255, 0.6);
        opacity: 0.5;
        margin: 30px 0;
      }
      .t1:nth-child(1) {
        border-bottom: 1px solid rgba(255, 255, 255, 1);
      }
    }
    .TopBox_right {
      padding: 10px;
      background: #f8f8f8;
      flex: 1;
      display: inline-flex;
      flex-wrap: wrap;
      .TopBox_right_Item:nth-child(3n + 2) {
        margin-left: 10px;
        margin-right: 10px;
      }
      .TopBox_right_Item:nth-child(7),
      .TopBox_right_Item:nth-child(8),
      .TopBox_right_Item:nth-child(9) {
        margin-bottom: 0;
      }
      .TopBox_right_Item {
        position: relative;
        height: 140px;
        padding: 10px;
        background: #fff;
        width: calc(calc(100% / 3) - 20px - calc(20px / 3));
        text-align: left;
        margin-bottom: 10px;
        &:hover {
          cursor: pointer;
        }
        &:hover > .Item_BtnBox {
          cursor: pointer;
          display: inline-flex;
        }
        .newBg {
          position: absolute;
          right: 5px;
          top: 5px;
          width: 50px;
        }
        .Item_Title {
          font-size: 16px;
          width: calc(100% - 50px);
          font-weight: bold;
          color: #333333;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .Item_Txt {
          text-indent: 16px;
          margin:0px;
          line-height: 22px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          font-size: 13px;
          color: rgba(102, 102, 102, 1);
        }
        .Item_BtnBox {
          margin-top:5px;
          display: inline-flex;
          display: none;
          height: 25px;
          line-height: 25px;
          width: calc(100% - 20px);
          span {
            width: calc(50% - 30px);
            color: #fff;
            text-align: center;
            border-radius: 5px;
            font-size: 13px;
          }
          span:nth-child(1) {
            background: rgba(65, 96, 206, 1);
          }
          span:nth-child(2) {
            margin-left: 10px;
            background: rgba(255, 178, 91, 1);
          }
        }
      }
    }
  }
  // 2
  .Middle_TwoBox {
    margin-top: 80px;
    padding-bottom: 30px;
    .TwoBoxImg {
      transform: scale(0.8);
    }
    .TwoBox_middel {
      padding-bottom: 10px;
      padding-left: 10px;
      padding-right: 10px;
      display: inline-flex;
      width: calc(100% - 20px);
      margin-top: 50px;
      .ItemBox:nth-child(2) {
        margin: 0 20px;
      }
      .ItemBox {
        width: calc((100% - 40px) / 3);
        background: #ffffff;
        box-shadow: 0px 5px 20px -5.5px rgba(0, 0, 0, 0.1);
        border-radius: 5px;
        position: relative;
        height: auto;
        img {
          width: 100%;
          height: 130px;
        }
        .spanTitle{
          position: absolute;
          left:20px;
          top:10px;
          // right: 0;
          color:#ffff;
          font-size: 20px;
          font-weight: bolder;
        }
        .Item_Txt {
          height: fit-content;
          padding-bottom: 10px;
          width: 100%;
          padding: 5px 0;
          .TxtBox {
            width: calc(100% - 15px);
            padding: 5px;
            padding-right: 10px;
            display: inline-flex;
            justify-content: space-between;
            align-items: center;
            &:hover {
              color: rgba(70, 106, 233, 1);
              cursor: pointer;
            }
            div {
              width: calc(100% - 100px);
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              font-size: 15px;
              text-align: left;
            }
            div::before {
              content: "⦁";
              padding-right: 5px;
            }
            span {
              font-size: 12px;
              width: fit-content;
            }
          }
        }
      }
    }
  }
}
// 3
.Middle_ThreeBox {
  width: 100%;
  height: 450px;
  background: url("../assets/bg-5.png") no-repeat center;
  margin-top: 60px;
  padding-top: 30px;
  background-size: 100% 100%;
  .ThreeContBox {
    width: 1260px;
    margin: 0 auto;
    .TwoBoxImg {
      transform: scale(0.8);
    }
    .ThreeBox {
      margin-top: 30px;
      width: 100%;
      display: inline-flex;
      height: 100%;
      .ItemBox {
        flex: 1;
        img {
          width: 60px;
          margin: 0 auto;
        }
        div {
          color: #fff;
        }
        .Item_t1 {
          font-size: 15px;
          padding-top: 15px;
          font-weight: bold;
        }
        .Item_t2 {
          font-size: 15px;
          color: rgba(254, 184, 94, 1);
          padding: 2px 0;
        }
        .Item_t3 {
          width: 45%;
          margin: 0 auto;
          text-align: center;
          font-size: 13px;
        }
      }
    }
  }
}
// 4
.Middle_FourBox {
  width: 1260px;
  margin: 50px auto;
  overflow: hidden;
  .FourContBox {
    width: 100%;
    .TwoBoxImg {
      transform: scale(0.8);
    }
    .ItemBox {
      display: inline-flex;
      img {
        width: 200px;
        height: 250px;
      }
      .ItemTxt {
        height: 210px;
        margin-left: 30px;
        text-align: left;
        display: inline-flex;
        flex-direction: column;
        .ItemT1 {
          color: #333;
          font-size: 18px;
          font-weight: bold;
          margin-top: 20px;
        }
        .ItemT2 {
          margin-top: 15px;
          font-size: 13px;
          max-height: 150px;
          letter-spacing: 2px;
          line-height: 30px;
        }
        .ItemT3 {
          margin-top: 15px;
          width: fit-content;
          font-size: 12px;
          padding: 5px 50px;
          border: 1px solid #eeeeee;
          border-radius: 23px;
          font-weight: 400;
          color: rgba($color: #000000, $alpha: 0.8);
          &:hover {
            cursor: pointer;
            background: #466ae9;
            color:#fff;
          }
        }
      }
    }
  }
}
</style>